// extracted by mini-css-extract-plugin
export default {"bg":"kAZTpn","inlineContent":"FtiNVl","pageWrapper":"r4zfqq","root":"sMghaC"};